export default "__VITE_ASSET__BYHKgO1C__"